<template>
  <v-container fluid grid-list-sm>
    <v-container grid-list-xl fluid style="padding:1px;">
      <v-layout>
        <v-flex lg3 sm4 xs8>
          <mini-statistic
            icon="border_clear"
            title="可用数量"
            :sub-title="num_empty.toString()"
            color="light-blue"
          >
          </mini-statistic>
        </v-flex>
        <v-flex lg3 sm4 xs8>
          <mini-statistic
            icon="border_outer"
            title="待发数量"
            :sub-title="num_unout.toString()"
            color="success"
          >
          </mini-statistic>
        </v-flex>
        <v-flex lg3 sm4 xs8>
          <mini-statistic
            icon="border_all"
            title="待回数量"
            :sub-title="num_out.toString()"
            color="warning"
          >
          </mini-statistic>
        </v-flex>
        <v-flex lg3 sm4 xs8>
          <mini-statistic
            icon="blur_off"
            title="报废数量"
            :sub-title="num_scrap.toString()"
            color="error"
          >
          </mini-statistic>
        </v-flex>
      </v-layout>
    </v-container>
    <v-toolbar dense color="white">
      <v-text-field
        v-model="search_str"
        label="搜索"
        prepend-icon="search"
        clearable
        style="width:100px;"
        >
      </v-text-field>
      <v-checkbox label="已发" v-model="sel_out" style="width: 80px"></v-checkbox>
      <v-checkbox label="未发" v-model="sel_unout" style="width: 80px"></v-checkbox>
      <v-checkbox label="报废" v-model="sel_scrap" style="width: 80px"></v-checkbox>
      <v-btn @click="reload" small color="primary"><v-icon>search</v-icon>搜索</v-btn>
      <v-spacer></v-spacer>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-dialog v-model="dlgAdd" max-width="500px">
        <template v-slot:activator="{attrs, on}">
          <v-btn v-bind="attrs" v-on="on" small color="success" @click="addIt" dark class="mb-2"><v-icon>add</v-icon>仓储笼</v-btn>
        </template>
        <v-card>
          <v-card-title>添加仓储笼</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="ed.cage_no"
              label="仓储笼号">
            </v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dlgAdd=false">取消</v-btn>
            <v-btn color="primary" @click="saveA">确定</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
      <v-data-table
        v-model="items_selected"
        :items="items"
        :headers="headers"
        :server-items-length="pagination.totalItems"
        :loading="loading"
        hide-default-footer
        show-select
        class="elevation-2"
      >
      <template v-slot:item.cage_no="{item}">
        <span :class="'st' + item.status">{{item.cage_no}}</span>
      </template>
      <template v-slot:item.act="{item}">
        <v-tooltip bottom>
          <template v-slot:activator="{attrs, on}">
            <v-btn v-bind="attrs" v-on="on" small icon @click="edIt(item.id)" color="success"><v-icon>edit</v-icon></v-btn>
          </template>
          <span>编辑</span></v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{attrs, on}">
            <v-btn v-bind="attrs" v-on="on" small icon @click="hisIt(item)" color="success"><v-icon>list</v-icon></v-btn>
          </template>
          <span>历史</span>
        </v-tooltip>
      </template>
      <template slot="no-data">
        没有记录
      </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination v-model="pagination.page" :length="pagination.totalPages"></v-pagination>
      </div>
      <cage-seltr ref="cage_seltr" @rmCage="onRmCageNo" @doOk="onCageOk"></cage-seltr>

      <v-dialog v-model="dlgCage" max-width="800px">
        <v-card>
          <v-card-title :class="'st' + ed.status">
            仓储笼: {{ ed.cage_no}}
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="bAout"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                  <template v-slot:activator="{attrs, on}">
                    <v-text-field v-bind="attrs" v-on="on" v-model="ed.a_out" label="实际发出日期" prepend-icon="event" readonly></v-text-field>
                  </template>
                  <v-date-picker v-model="ed.a_out" label="实际发出日期" locale="zh-cn" @input="bAout=false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="bAin"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                  <template v-slot:activator="{attrs, on}">
                    <v-text-field v-bind="attrs" v-on="on" v-model="ed.a_in" label="实际收回日期" prepend-icon="event" readonly></v-text-field>
                  </template>
                  <v-date-picker v-model="ed.a_in" label="实际收回日期" locale="zh-cn" @input="bAin=false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-btn v-if="canScrap()" color="error" @click="scrapIt">报废</v-btn>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="ed.note"
                    label="备注">
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                装笼产品：
                  <div v-html="ed.products"></div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="cancel">取消</v-btn>
            <v-btn color="primary" @click="save">确定</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dlgCageHis" max-width="1000px">
        <v-card>
          <v-card-title>
            仓储笼历史: {{his_cage_no}}
          </v-card-title>
          <v-card-text>
            <v-data-table
              :items="his_items"
              :headers="his_headers"
              :server-items-length="his_pgn.totalItems"
              hide-default-footer
              class="elevation-2"
            >
              <template v-slot:item.act="{item}">
                <v-tooltip v-if="item.canDereturn && canDereturnCage" bottom>
                  <template v-slot:activator="{attrs, on}">
                    <v-btn v-bind="attrs" v-on="on" color="error" x-small circle icon>
                      <v-icon @click="deReturnCage(item.id)">close</v-icon>
                    </v-btn>
                  </template>
                  <span>取消收回</span>
                </v-tooltip>
              </template>
              <template slot="no-data">
                没有记录
              </template>
            </v-data-table>
            <div class="text-xs-center pt-2">
              <v-pagination v-model="his_pgn.page" :length="his_pgn.totalPages"></v-pagination>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="cancelHis">确定</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-container>
</template>

<style>
table.v-table tbody td.st0, table.v-table tbody td.st1, table.v-table tbody td.st3 {
  font-size: 22px;
}
span.st0, span.st1, span.st2, span.st3 {
  display: inline-block;
  width:60px;
  height:100%;
  font-size:16px;
  text-align: center;
  vertical-align: middle;
  line-height: 40px;
}
.st0 {
  background-color:lightgreen;
}
.st1 {
  background-color:lightcoral;
}
.st3 {
  background-color:gray;
}
.v-card__title {
  font-size: 20px;
}
</style>

<script>
import { addCage, getCage, setCageP, getCageList, getCageNums, getCageHis, scrapCage, deReturnCage } from '@/api/cage'
import { getProducePotCageList } from '@/api/produce'
import { Int2Date, Date2Int, MsgError, MsgWarn } from '@/libs/util'
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic'
import { canDo } from '@/libs/tools'
import CageSeltr from '@/views/components/CageSeltr'

export default {
  components: {
    MiniStatistic,
    CageSeltr
  },
  data: () => ({
    num_empty: 0,
    num_unout: 0,
    num_out: 0,
    num_scrap: 0,
    search_str: '',
    sel_out: false,
    sel_unout: false,
    sel_scrap: false,
    bPout: false,
    bPin: false,
    bAout: false,
    bAin: false,
    items: [],
    items_selected: [],
    items_selected_save: [],
    ppotitems: [],
    dlgCage: false,
    dlgAdd: false,
    ed: {
      id: 0,
      cage_no: '',
      p_out: '',
      p_in: '',
      a_out: '',
      a_in: '',
      note: ''
    },
    pagination: {
      page: 1,
      sortBy: '',
      descending: false,
      rowsPerPage: 10,
      totalItems: 0,
      totalPages: 0
    },
    loading: false,
    headers: [
      { text: '仓储笼号', value: 'cage_no', sortable: false, width: 10 },
      { text: '发出日期', value: 'a_out', sortable: false, width: 120 },
      { text: '收回日期', value: 'a_in', sortable: false, width: 120 },
      { text: '备注', value: 'note', sortable: false },
      { text: '装笼', value: 'products', sortable: false, width: 400 },
      { text: '操作', value: 'act', sortable: false, width: 160 }
    ],
    his_pgn: {
      page: -1,
      sortBy: '',
      descending: false,
      rowsPerPage: 10,
      totalItems: -1,
      totalPages: -1
    },
    his_cage_no: 0,
    his_cage_st: 0,
    dlgCageHis: false,
    his_items: [],
    his_headers: [
      { text: '发出日期', value: 'a_out', sortable: false, width: 120 },
      { text: '收回日期', value: 'a_in', sortable: false, width: 120 },
      { text: '备注', value: 'note', sortable: false },
      { text: '装笼', value: 'products', sortable: false, width: 400 },
      { text: '', value: 'act', sortable: false }
    ]
  }),
  methods: {
    saveA () {
      let cageNo = parseInt(this.ed.cage_no)
      if (cageNo <= 0) {
        MsgError('仓储笼号不正确')
        return
      }
      addCage(cageNo).then(res => {
        this.dlgAdd = false
        this.reload()
      })
    },
    addIt () {
      this.ed.cage_no = 0
    },
    edIt (id) {
      getCage(id).then(res => {
        this.ed.id = res.data.id
        this.ed.cage_no = res.data.cage_no
        this.ed.p_out = Int2Date(res.data.p_out)
        this.ed.p_in = Int2Date(res.data.p_in)
        this.ed.a_out = Int2Date(res.data.a_out)
        this.ed.a_in = Int2Date(res.data.a_in)
        this.ed.note = res.data.note
        this.ed.status = res.data.status
        this.ed.products = res.data.products.replace(/\n/g, '<br>')
      })
      this.dlgCage = true
    },
    cancelHis () {
      this.dlgCageHis = false
    },
    hisIt (item) {
      this.his_cage_no = item.cage_no;
      this.his_cage_st = item.status;
      this.loadHis()
      this.dlgCageHis = true
    },
    deReturnCage(cage_id) {
      this.$swal.fire({
        title: '警告',
        text: '确实要取消收回' + this.his_cage_no + '号仓储笼吗? ',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then((result) => {
        if (result.isConfirmed) {
          this.doDereturnCage(cage_id);
        }
      })
    },
    doDereturnCage(cage_id) {
      deReturnCage(cage_id).then(res => {
        this.loadHis();
        this.reload();
      })
    },
    in3Days(dn) {
      var d = new Date()
      d.setDate(d.getDate() - 3);
      let d3 = Date2Int(d);
      return (dn > d3);
    },
    loadHis () {
      if (this.his_cage_no <= 0) {
        return
      }
      let d = {
        'cageNo': this.his_cage_no,
        'page': this.his_pgn.page,
        'perPage': this.his_pgn.rowsPerPage
      }
      getCageHis(d).then(res => {
        this.his_items = res.data.items
        this.his_items.forEach(e => {
          e.p_out_s = Int2Date(e.p_out)
          e.p_in_s = Int2Date(e.p_in)
          e.a_out_s = Int2Date(e.a_out)
          e.a_in_s = Int2Date(e.a_in)
          e.products = e.products.replace(/\n/g, '<br>')
          e.canDereturn = (this.his_cage_st === 0 && this.in3Days(e.a_in));
        })
        if (res.data._meta.page > res.data._meta.total_pages) {
          this.his_pgn.page = res.data._meta.total_pages
        } else {
          this.his_pgn.page = res.data._meta.page
        }
        if (this.his_pgn.page < 1) this.his_pgn.page = 1
        this.his_pgn.totalPages = res.data._meta.total_pages
        this.his_pgn.totalItems = res.data._meta.total_items
      })
    },
    loadPots (id) {
      this.ppotitems = []
      getProducePotCageList(id).then(res => {
        var oo = null
        for (var i = 0; i < res.data.length; ++i) {
          let it = res.data[i]
          if (oo !== null && it.pd_id !== oo['pd_id']) {
            this.ppotitems.push(oo)
            oo = null
          }
          if (oo === null) {
            oo = Object()
            oo['id'] = it.id
            oo['pd_id'] = it.pd_id
            oo['pd_no'] = it.pd_no
            oo['pn_date'] = Int2Date(it.pn_date)
            oo['pn_num'] = it.pn_num
            oo['formula_name'] = it.formula_name
            oo['formula_code'] = it.formula_code
            oo['formula_color'] = it.formula_color
            oo['pots'] = []
          }
          oo['pots'].push(it.pot_no)
        }
        if (oo !== null) {
          this.ppotitems.push(oo)
        }
        this.ppotitems.forEach(e => {
          e['pots_s'] = e['pots'].join(',')
        })
      })
    },
    clear () {
      this.ed.id = 0
      this.ed.cage_no = ''
      this.ed.p_out = ''
      this.ed.p_in = ''
      this.ed.a_out = ''
      this.ed.a_in = ''
      this.ed.note = ''
    },
    cancel () {
      this.dlgCage = false
    },
    save () {
      var pOut = Date2Int(this.ed.p_out)
      var pIn = Date2Int(this.ed.p_in)
      var aOut = Date2Int(this.ed.a_out)
      var aIn = Date2Int(this.ed.a_in)
      if (this.ed.status === 3) {
        MsgWarn('报废仓储笼不可修改')
        return
      }
      setCageP(this.ed.id, pOut, pIn, aOut, aIn, this.ed.note).then(res => {
        this.dlgCage = false
        this.clear()
        this.reload()
      })
    },
    scrapIt () {
      this.$swal.fire({
        title: '警告',
        text: '确实要报废该仓储笼吗? 报废后，该笼号不再可用。',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then((result) => {
        if (result.isConfirmed) {
          this.doScrap(this.ed.id);
        }
      })
    },
    doScrap (id) {
      scrapCage(id).then(res => {
        this.dlgCage = false
        this.clear()
        this.reload()
      })
    },
    reload () {
      let d = {
        'kw': this.search_str,
        'out': this.sel_out ? 1 : 0,
        'unout': this.sel_unout ? 1 : 0,
        'scrap': this.sel_scrap ? 1 : 0,
        'page': this.pagination.page,
        'perPage': this.pagination.rowsPerPage
      }
      getCageNums().then(res => {
        this.num_empty = res.data.num_empty
        this.num_unout = res.data.num_unout
        this.num_out = res.data.num_out
        this.num_scrap = res.data.num_scrap
      })
      this.loading = true
      this.items_selected_save = []
      this.items_selected = []
      getCageList(d).then(res => {
        this.items = res.data.items
        this.items.forEach(e => {
          e.p_out_s = Int2Date(e.p_out)
          e.p_in_s = Int2Date(e.p_in)
          e.a_out_s = Int2Date(e.a_out)
          e.a_in_s = Int2Date(e.a_in)
          e.products = e.products.replace(/\n/g, '<br>')
          if (this.$refs.cage_seltr.inCages(e.cage_no)) {
            this.items_selected.push(e)
            this.items_selected_save.push(e)
          }
        })
        if (res.data._meta.page > res.data._meta.total_pages) {
          this.pagination.page = res.data._meta.total_pages
        } else {
          this.pagination.page = res.data._meta.page
        }
        this.pagination.totalPages = res.data._meta.total_pages
        this.pagination.totalItems = res.data._meta.total_items
        this.loading = false
      })
    },
    canScrap () {
      return canDo(['admin', 'scrap_cage'], this.$store.state.user.access) && this.ed.status !== 3
    },
    cageInItems (cageNo, items) {
      for (var i = 0; i < items.length; ++i) {
        if (items[i].cage_no === cageNo) return true
      }
      return false
    },
    rmCageNo (cageNo, items) {
      for (var i = 0; i < items.length; ++i) {
        if (items[i].cage_no === cageNo) {
          items.splice(i, 1)
          return
        }
      }
    },
    onRmCageNo (cageNo) {
      this.rmCageNo(cageNo, this.items_selected)
      this.rmCageNo(cageNo, this.items_selected_save)
    },
    onCageOk () {
      this.items_selected = []
      this.items_selected_save = []
      this.reload()
    }
  },
  computed: {
    canDereturnCage () {
      return canDo(['admin', 'dereturncage'], this.$store.state.user.access)
    }
  },
  watch: {
    items_selected: {
      handler () {
        if (this.items_selected.length > this.items_selected_save.length) {
          // add new one
          this.items_selected.forEach(e => {
            if (!this.cageInItems(e.cage_no, this.items_selected_save)) {
              this.items_selected_save.push(e)
              this.$refs.cage_seltr.Add(e)
            }
          })
        } else {
          // remove
          for (var i = this.items_selected_save.length - 1; i >= 0; i--) {
            let e = this.items_selected_save[i]
            if (!this.cageInItems(e.cage_no, this.items_selected)) {
              this.items_selected_save.splice(i, 1)
              this.$refs.cage_seltr.rmCageNo(e.cage_no)
            }
          }
        }
      }
    },
    pagination: {
      handler () {
        this.reload()
      },
      deep: true
    },
    his_pgn: {
      handler () {
        this.loadHis()
      },
      deep: true
    }
  },
  mounted () {
    this.reload()
  }
}
</script>
